import type { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { LoadingState } from "./AsyncState";

export function ProtectedRoute({
  children,
  permission,
  subject = "staff"
}: PropsWithChildren<{ permission?: string; subject?: "staff" | "citizen" }>) {
  const { session, loading, can } = useAuth();
  const location = useLocation();

  if (loading)
    return (
      <main className="center-screen">
        <LoadingState label="جارٍ التحقق من الجلسة" />
      </main>
    );
  if (!session) return <Navigate to="/login" state={{ from: location }} replace />;
  if (session.subjectType !== subject)
    return <Navigate to={session.subjectType === "citizen" ? "/citizen" : "/"} replace />;
  if (permission && !can(permission)) return <Navigate to="/forbidden" replace />;
  return children;
}
